import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { compose, withHandlers } from 'recompose';
import { pickBy } from 'lodash';

import { commonServicesProvider } from './hoc';
import ScrollToTop from '../hoc/ScrollToTop';
import withKioskProp from '../hoc/WithKioskProp';
import { fetchShop } from '../shops/actions';
import { fetchBarbers } from '../barbers/actions';
import { getAllowMultipleServices } from '../barbers/selectors';
import { fetchServices } from './actions';
import {
  generateUrlString,
  toggleItemInArray,
} from '../utils/helpers';
import Services from './components/Services';


const SCROLL_OFFSET = -1;

const fetchData = compose(
  withRouter,
  connect(null, {
    fetchShop,
    fetchBarbers,
    fetchServices,
  }),
  withHandlers({
    fetchData: props => () =>
      props
        .fetchShop(props.params.shopRoute, props.urlPattern)
        .then(() => props.fetchBarbers(props.params.shopRoute, props.urlPattern))
        .then(() =>
          props.fetchServices(
            props.params.shopRoute,
            props.params.barberRoute,
            props.params,
            props.urlPattern,
            props.kiosk,
          ),
        ),
  }),
);

const generateUrl = compose(
  withRouter,
  connect((state, ownProps) => ({
    allowMultipleServices: getAllowMultipleServices(state, ownProps.params.barberRoute, ownProps.params.shopRoute),
    selectedIds: ownProps.params.serviceId || '',
  })),
  withHandlers({
    generateUrlString: props => (id) => {
      const serviceId = (() => {
        if (!props.allowMultipleServices) return id;
        if (!props.selectedIds) return id;

        return toggleItemInArray(props.selectedIds.split(';'), id).join(';');
      })();

      return generateUrlString(
        pickBy({
          shopRoute: props.params.shopRoute,
          barberRoute: props.params.barberRoute,
          serviceId,
        }),
        props.urlPattern,
      );
    },
  }),
  withHandlers({
    onServiceClick: props => id => (e) => {
      e.preventDefault();
      props.router.replace(props.generateUrlString(id));
    },
  })
);

export default compose(
  withKioskProp,
  fetchData,
  commonServicesProvider,
  generateUrl,
  ScrollToTop(SCROLL_OFFSET),
)(Services);



// WEBPACK FOOTER //
// ./src/app/services/Services.jsx